"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { DataBuilderFormField } from '../DataBuilderFormField.mjs';
import { makeDataField } from '../index.mjs';

const ConcatFormula = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "formula", ref, onClick: props.onClick, onDelete: props.onDelete, children: [
      /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Function }),
      " Combine strings"
    ] });
  }
);
ConcatFormula.displayName = "ConcatFormula";
function ConcatFormulaDropdown({
  onChange,
  formula,
  variablesSchema,
  optionFactories
}) {
  function handleOnChange(value2) {
    onChange?.({
      $concat: value2
    });
  }
  const isShortcutFormulaSyntax = Array.isArray(formula.args);
  const value = isShortcutFormulaSyntax ? { values: formula.args } : formula.args ?? {};
  const field = makeDataField({
    schema: {
      type: "object",
      required: ["values"],
      properties: {
        values: {
          type: "array",
          items: {
            type: "string"
          }
        },
        delimiter: {
          type: "string"
        }
      }
    },
    value,
    variablesSchema,
    optionFactories
  });
  return /* @__PURE__ */ jsx(DataBuilderFormField, { field, onChange: handleOnChange });
}

export { ConcatFormulaDropdown, ConcatFormula as default };
